module.exports = __webpack_public_path__ + "static/media/Git_icon.05a474f9.svg";